import {
  Directive, ElementRef,
  Injector,
  Optional, ViewChild
} from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, propFactory as PropertiesFactory, provideAsWidgetRef, Parent, register, styler, updateWidgetProps } from "@wm/components-base";
import {setPropertiesdisplayformat, setPropertiesTextWidget} from "../../formWidgetUtils";
import { runtimeEventManager, setAttr } from '@wm/core';
import {keys} from "lodash-es";


const DEFAULT_CLS = 'wm-text';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-text',
  hostClass: 'app-input-wrapper',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

let isNativeMobileApplicationType: boolean = false;
let projectService:any;

@Directive({
  selector: 'input[type="text"], input:not([type]), input[type="password"], input[type="search"],' +
    ' input[type="tel"], input[type="number"], input[type="color"], input[type="url"], input[type="email"],' +
    ' input[type="date"], input[type="datetime-local"], input[type="month"], input[type="time"], input[type="week"]',
  providers: [
    provideAsWidgetRef(TextComponent)
  ],
  exportAs: 'wmText',
  standalone: true
})
export class TextComponent extends StylableComponent {
  static initializeProps = register('wm-text');
  public required: boolean;
  public maxchars: number;
  public regexp: string;
  public displayformat: string;
  public disabled: boolean;
  public type: any;
  public name: string;
  public readonly: boolean;
  public tabindex: any;
  public placeholder: any;
  public shortcutkey: string;
  public autofocus: boolean;
  public autocomplete: any;
  public maskVal: any;
  public isFocused: boolean;
  public hint: string;
  public trailingiconclass:string; 
  public leadingiconclass: string;
  dataval: any;
  @ViewChild('input', {static: true}) inputEl: ElementRef;


  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    projectService = runtimeEventManager.getService('projectService');
    isNativeMobileApplicationType = projectService.isNativeMobileApplicationType();
    if( isNativeMobileApplicationType) {
      let mobileProps = PropertiesFactory.getPropertiesOf('', ['wm.text.native_mobile']);
      updateWidgetProps(this.widgetProps, true, keys(this.widgetProps), keys(mobileProps));
      let propsToHide = keys(mobileProps);
      const includeProps = ['autocomplete', 'accessibilityrole', 'accessibilitylabel'];
      const updatedList = propsToHide.filter(item => !includeProps.includes(item));
      updateWidgetProps(this.widgetProps, true, keys(this.widgetProps), updatedList); 
    }
  }

  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('input.app-textbox') || this.nativeElement;
  }

  get datavalue() {
    return this.dataval;
  }

  set datavalue(datavalue) {
    this.dataval = datavalue;
  }
  override ngOnInit() {
    if(this.getAttr('placeholder.bind')) {
      super.onPropertyChange('placeholder', 'bind:'+this.getAttr('placeholder.bind'), '');
    }
    super.ngOnInit();
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    let wp = this.widgetProps;
    switch (key) {
      case 'type':
        if (!isNativeMobileApplicationType) {
          setPropertiesTextWidget(wp, nv, this);
          setAttr(this.nativeElement, key, nv)
        }
        break;
      case 'autocomplete':
        (nv === true || nv === 'true') ? this.nativeElement.removeAttribute(key) : this.nativeElement.setAttribute(key, 'off');
        break;
      case 'displayformat':
        this.placeholder = nv ? '' : this.placeholder;
        setPropertiesdisplayformat(wp, nv);
        break;
      case 'leadingiconclass':
      case 'trailingiconclass':
        this.toggleIconClass(key,nv, ov)
        break;
      case 'supportingtext':
        const supportTextElement = this.nativeElement.parentElement?.querySelector('[name="showsupportingtext"]');
        if (supportTextElement) {
          supportTextElement.textContent = nv ?? '';
        }     
        break;
      default:
        super.onPropertyChange(key, nv, ov);
    }
  }

  toggleIconClass(key: string, newVal: string, ov: string) {
    const iconElement = this.nativeElement.parentElement?.querySelector('.' + key);

    if (!iconElement) return;

    if (ov) {
      ov.split(' ').forEach(cls => {
        cls && iconElement.classList.remove(cls);  // remove old classes
      });
    }
    if (newVal) {
      newVal.split(' ').forEach(cls => {
        cls && iconElement.classList.add(cls);  // add new classes
      });
    }

    const iconButtonElement = this.nativeElement.parentElement?.querySelector('[name="'+key+'"]');
    if(newVal){
      iconButtonElement?.classList.remove('ng-hide')
    }else{
      iconButtonElement?.classList.add('ng-hide')
    }

    if(key === 'leadingiconclass' && newVal){
      this.nativeElement.classList.add('with-leading-icon')
    }else if(key === 'leadingiconclass'){
      this.nativeElement.classList.remove('with-leading-icon')
    }

  }


 /**
  * Returns the data-type for properties in the widget.
  * Pushes the meta data against these types in $rs.dataTypes, as $rs.dataTypes will be referred for the data-types returned.
  * @param prop
  * @returns {*}
  */
  getPropertyType(prop: any,types: any) {
    let type;
    switch (prop) {
      case 'datavalue':
        switch (this.type) {
          case 'number':
          case 'time':
            type = this.type;
            break;
          case 'datetime-local':
            type = 'datetime, timestamp';
            break;
          case 'date':
          case 'month':
          case 'week':
            type = 'date';
            break;
          default:
            type = 'string';
        }
        break;
    }
    return type;
  }

}

